<!-- Hero Section -->
<section id="hero" class="hero section">
    <div class="hero-bg">
        <img src="/img/hero-bg.jpg" alt="">
    </div>
    <div class="container text-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <h1 data-aos="fade-up">Welcome to <span>All-In-One Invoice</span></h1>
            <p data-aos="fade-up" data-aos-delay="100">Streamline Your Billing - Free Online Invoices, Instant PDF Magic!<br></p>
            <div class="d-flex" data-aos="fade-up" data-aos-delay="200">
                <a class="btn-get-started" [routerLink]="['/invoice']">Generate Free Invoice</a>
            </div>
            <img src="/img/mine/Invoice-amico_green.png" class="img-fluid hero-img" alt="" data-aos="zoom-out" data-aos-delay="300">
        </div>
    </div>
</section>
<!-- /Hero Section -->